import React, { useEffect } from "react";
import { Box, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useTranslation } from "react-i18next";
import { useSound } from "../../../../../../context/juno/SoundContext";
import { ColumnBox } from "../../../../../../utils/styledBox";

const LyricControl: React.FC = () => {
  const { t } = useTranslation();
  const { lyric, setLyric, aiEngine } = useSound();
  const [onlyEnglish, setOnlyEnglish] = React.useState(false);

  useEffect(() => {
    if (aiEngine === "DIFFRHYTHM") {
      setOnlyEnglish(true);
    }
  }, [aiEngine]);

  return (
    <ColumnBox>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
        <Typography variant="body2">{t("juno.sound.params.lyric")}</Typography>
        <Tooltip title={t("juno.sound.params.lyricHelp")} placement="top">
          <IconButton size="small">
            <InfoIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <TextField
        value={lyric}
        onChange={(e) => setLyric(e.target.value)}
        multiline
        minRows={1}
        maxRows={10}
        placeholder={t("juno.sound.params.lyricPlaceholder")}
        variant="standard"
        fullWidth
        inputProps={{ maxLength: aiEngine === "MINIMAX" ? 200 : 1000 }} // 最大文字数を設定
      />
      {onlyEnglish && (
        <Typography variant="caption" color="warning.main">
          {t("juno.sound.params.lyricOnlyEnglish")}
        </Typography>
      )}
    </ColumnBox>
  );
};

export default LyricControl;
